<template>
  <div style="padding: 15px;" class="containerTable">
    <vxe-toolbar
      id="toolbarId_ba1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('bankCardManage_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <el-button v-if="getLimit('bankCardManage_add_button')" @click="funcAdd"
          >新增</el-button
        >
        <el-button
          v-if="getLimit('bankCardManage_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isDefault"
          title="是否默认卡"
          :formatter="formatterIsDefault"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isDefault"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isDefaultOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isDeleted"
          title="银行卡状态"
          :formatter="formatterIsDeleted"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.deleted" placeholder="请选择" clearable>
            <el-option
              v-for="item in DeletedOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="联系人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userPhone"
          title="用户电话"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userPhone"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyType"
          title="角色类型"
          :formatter="formatterRole"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.partyType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in roleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="开户名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mobile"
          title="银行预留手机号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.mobile" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="account"
          title="银行卡号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.account"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bankNo"
          title="开户银行"
          :formatter="formatterBank"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bankName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="accountCity"
          title="开户城市"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.accountCity"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="branche"
          title="开户网点"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.branche"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="账户类型"
          :formatter="formatterType"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.type" placeholder="请选择" clearable>
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="修改时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('bankCardManage_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('bankCardManage_delete_button') &&
                scope.row.isDeleted === 0
            "
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <!-- 恢复     v-if="
              scope.row.isDeleted === 1 && getLimit('bankcard_reset_button')
            "-->
          <el-tooltip
            v-if="
              scope.row.isDeleted === 1 && getLimit('bankcard_reset_button')
            "
            class="item"
            effect="dark"
            content="恢复"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="recoverDeletedBankCardApi(scope.row)"
            >
              <img
                style="width: 15px; height: 15px;display: inline-block;transform: translateY(3px);"
                src="@/assets/icon/reset.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="800"
      height="98%"
      resize
    >
      <compAdd
        ref="addRef"
        :payment-type="paymentType"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="800"
      height="99%"
      resize
    >
      <compEdit
        ref="editRef"
        :payment-type="paymentType"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/bankCardAdd.vue";
import compEdit from "./components/bankCardEdit.vue";
import request from "@/utils/request";
import { getListDict, recoverDeletedBankCard } from "@/api/commonApi";
export default {
  name: "BankCardList",
  components: {
    compAdd,
    compEdit
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/bankCard/exportBankCardList", //导出接口
        name: "银行管理"
      },
      bankList: [],
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      paymentType: "",
      listQuery: {
        gmtCreatedRange: "",
        gmtModifiedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        deleted: 2
      },
      // 默认卡
      isDefaultOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 账户类型
      typeOptions: [
        { label: "个人账户", value: 1 },
        { label: "企业账户", value: 2 }
      ],
      DeletedOptions: [
        { label: "正常", value: 0 },
        { label: "已删除", value: 1 },
        { label: "全部", value: 2 }
      ],
      roleOptions: [
        //{ label: "超级管理员", value: 'SUPER_ADMIN' },
        //{ label: "平台管理员", value: 'PLAT_ADMIN' },
        { label: "实际承运人", value: "DRIVER" },
        { label: "车队长", value: "DRIVER_LEADER" },
        { label: "个体托运人", value: "SHIPMENT" },
        { label: "企业托运人", value: "SHIPMENT_COMPANY" }
        //{ label: "员工", value: 'STAFF' },
        //{ label: "加油站", value: 'GAS_STATION' },
        //{ label: "住户", value: 'HOUSEHOLD' }
      ]
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    // 获取数据字典： 银行
    getListDict({ types: "bank" }).then(response => {
      this.bankList = response.data.filter(item => item.type === "bank")[0][
        "dictList"
      ];
      this.findList();
    });
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    if (dataBranch.partyGroupConfigCacheMap.payment_type) {
      this.paymentType =
        dataBranch.partyGroupConfigCacheMap.payment_type.configValue;
    }
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/bankCard",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    recoverDeletedBankCardApi(row) {
      this.$confirm("确认恢复吗？").then(_ => {
        recoverDeletedBankCard({ code: row.code }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 添加方法
    funcAdd() {
      this.$refs.addRef.getInfo();
      this.modelAddFlag = true;
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？").then(_ => {
        request({
          url: `/ntocc-basic-api/bankCard`,
          method: "delete",
          params: { codes: row }
        }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 翻译是否默认
    formatterIsDefault({ cellValue }) {
      const item = this.isDefaultOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterIsDeleted({ cellValue }) {
      const item = this.DeletedOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterRole({ cellValue }) {
      const item = this.roleOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译账户类型
    formatterType({ cellValue }) {
      const item = this.typeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译开户银行
    formatterBank({ cellValue }) {
      const item = this.bankList.find(item => item.code === cellValue);
      return item ? item.name : "";
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
      }
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
